import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { GrossReceiptsStatusView } from "./GrossReceiptsStatusView";
import { GrossReceiptsStatusViewStore } from "../../store/GrossReceiptsStatusViewStore";
import { useStore } from "../../../../hooks";

export const GrossReceiptsStatusViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/grossReceiptsStatus/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new GrossReceiptsStatusViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <GrossReceiptsStatusView grossReceiptsStatusViewStore={store} />
      </PageLayout>
    </div>
  );
});
